import { z } from 'zod';

export const schema = z.object({
  NEXT_PUBLIC_WEB_APP_URL: z
    .url()
    .default('http://localhost:3003')
    .describe(
      'Public URL of the WebApp, used to build referral activation links',
    ),
  CRON_SECRET: z.string().default('').describe('Secret for cron jobs'),
  NEXT_PUBLIC_SENTRY_DSN: z
    .string()
    .url()
    .optional()
    .describe('Sentry DSN for error tracking'),
  NEXT_PUBLIC_PLATFORM: z
    .enum(['production', 'staging', 'development'])
    .default('development')
    .describe('Platform environment'),
  SECRET_COOKIE_PASSWORD: z
    .string()
    .optional()
    .describe('Secret for cookie encryption'),
});

const env = schema.safeParse({
  ...process.env,
  NEXT_PUBLIC_WEB_APP_URL: process.env.NEXT_PUBLIC_WEB_APP_URL,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_PLATFORM: process.env.NEXT_PUBLIC_PLATFORM,
});

if (!env.success) {
  console.error(
    '❌ backoffice - invalid environment variables:',
    env.error.format(),
  );
}

export default env.data!;
